import { useCallback, useEffect, useReducer, useState } from "react";
import { ConfigProvider, Button, Form, Input, Select, Modal, Spin, Empty, Pagination, message } from "antd";
import type { PaginationProps } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { publicPath } from "@/utils/base";
import { getProductManageDetail, setEnable } from "@/utils";
import { productNameReg } from "@/utils/constant";
import api from "@/api";
import { pageReducer, DEFAULT_PARAMS, CHANGE_PAGINATION, CHANGE_NAME } from "./block";
import "./index.less";

import dataJson from "@/../public/data.json";
import { cloneDeep } from "lodash-es";

const prefix = "productManage";

function productManage() {
  const { product_manage, req_err, create, two_bars, add_create, staging, name_label } = dataJson;
  const filterFormJson = product_manage.filter_form;
  const addFormJson = product_manage.add_form;

  const [kaihongState, kaihongDispatch] = useReducer(pageReducer, {
    page: 1,
    limit: 5,
  });
  const [kaihongList, setKaihongList] = useState<any[]>([]);
  const [kaihongTotal, setkaihongTotal] = useState<number>(0);
  const [kaihongLoading, setKaihongLoading] = useState(false);

  const [state, dispatch] = useReducer(pageReducer, DEFAULT_PARAMS);
  const [list, setList] = useState<any[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState(false);
  const [deviceTypeOptions, setDeviceTypeOption] = useState<any[]>([]);
  const [accessGatewayOption, setAccessGatewayOption] = useState<any[]>([]);
  const [operatingSystemOption, setOperatingSystemOption] = useState<any[]>([]);

  const [addOpen, setAddOpen] = useState(false);
  const [addOpenLoading, setAddFormLoading] = useState(false);
  const [filterForm] = Form.useForm();
  const [addForm] = Form.useForm();

  const { type } = useParams();
  const navigate = useNavigate();

  const onFilter = async () => {
    const filterFormValues = await filterForm.getFieldsValue();
    const data = {
      type: CHANGE_NAME,
      payload: filterFormValues.name,
    };
    kaihongDispatch(data);
    dispatch(data);
  };

  const onShowSizeChange: PaginationProps["onShowSizeChange"] = (current, pageSize) => {
    dispatch({
      type: CHANGE_PAGINATION,
      payload: {
        page: current,
        limit: pageSize,
      },
    });
  };

  const onKaihongShowSizeChange: PaginationProps["onShowSizeChange"] = (current, pageSize) => {
    kaihongDispatch({
      type: CHANGE_PAGINATION,
      payload: {
        page: current,
        limit: pageSize,
      },
    });
  };

  const showAddModal = () => {
    setAddOpen(true);
  };

  const handleAddOpenOk = async () => {
    try {
      const addValues = await addForm.validateFields();
      const { accessId } = addValues;
      const access = accessGatewayOption?.find((item: any) => {
        if (accessId === item?.id) {
          return item;
        }
      });
      const accessParams = {
        accessId: access.id,
        accessName: access.name,
        accessProvider: access.provider,
      };
      setAddFormLoading(true);
      const res: any = await api.createProductManage({
        name: addValues.name,
        description: addValues.description,
        operatingSystem: addValues.operatingSystem,
        deviceType: addValues.deviceType,
        model: addValues.model,
        ...accessParams,
      });
      if (res.code === 200) {
        message.success(product_manage.creat_success);
        setAddOpen(false);
        setEnable("");
        navigate(`${publicPath}/product_detail/info/${res.data.id}`);
      } else {
        setAddFormLoading(false);
        message.error(res.msg || req_err);
      }
    } catch (errorInfo: any) {
      setAddFormLoading(false);
    }
  };

  const handleAddCancel = () => {
    addForm.resetFields();
    setAddOpen(false);
  };

  const clickCard = (item: any, enable?: boolean) => {
    if (enable) {
      setEnable(enable.toString());
    } else {
      setEnable("");
    }
    // getProductManageDetail(item.id, () => {
      if (type === "analysis") {
        navigate(`${publicPath}/product_detail/distribution_board/${item.typeKey}/${item.id}`);
      } else {
        navigate(`${publicPath}/product_detail/info/${item.id}`);
      }
    // });
  };

  const getSuperProductDeviceQuery = (superAccessToken: string) => {
    return api.getSuperProductDeviceQuery(superAccessToken, {
      terms: [],
      current: 1,
      pageIndex: 0,
      pageSize: 11,
      sorts: [
        {
          name: "createTime",
          order: "desc",
        },
      ],
    });
  };
  const getSuperProductOperatingSystem = (superAccessToken: string) => {
    return api.getSuperProductOperatingSystem(superAccessToken);
  };
  const getAllOptions = async () => {
    const res: any = await api.getSuperAuth();
    if (res?.code == 200) {
      const { superAccessToken } = res.data;
      if (!superAccessToken) {
        return;
      }
      const [access, system]: any[] = await Promise.all([
        getSuperProductDeviceQuery(superAccessToken),
        getSuperProductOperatingSystem(superAccessToken),
      ]);
      if (access.status === 200) {
        setAccessGatewayOption(access?.result?.data);
      }
      if (system.status === 200) {
        setOperatingSystemOption(system?.result);
      }
    }

    {
      const res: any = await getOptions(product_manage?.dict?.deviceType);
      setDeviceTypeOption(res);
    }
  };

  // 获取字典
  const getOptions = async (type: string) => {
    try {
      const res: any = await api.getDict(type);
      if (res?.code == 200) {
        console.log(res?.data?.value);
        return res?.data?.value || [];
      } else {
        message.error(res.msg);
      }
    } catch (errorInfo: any) {
      message.error(errorInfo?.response?.data?.msg || req_err);
    }
  };

  const fetchKaihongPage = useCallback(() => {
    const data = {
      ...kaihongState,
      appBelong: "KAIHONG",
    };
    setKaihongLoading(true);
    api
      .getProductManagePage(data)
      .then((res: any) => {
        if (res.code === 200) {
          const dataCopy = cloneDeep(res.data.datas);
          const list = dataCopy.map((item: any) => {
            if (item.photoUrl) {
              item.iconImg = item.photoUrl.includes("http") ? item.photoUrl : null;
            }
            return item;
          });
          setKaihongList(list);
          setkaihongTotal(Number(res?.data?.total));
          setKaihongLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
        setkaihongTotal(0);
        setKaihongList([]);
      });
  }, [kaihongState]);

  const fetchPage = useCallback(() => {
    const data = {
      ...state,
      appBelong: "PERSONAL",
    };
    setLoading(true);
    api
      .getProductManagePage(data)
      .then((res: any) => {
        if (res.code === 200) {
          const dataCopy = cloneDeep(res.data.datas);
          const list = dataCopy.map((item: any) => {
            if (item.photoUrl) {
              item.iconImg = item.photoUrl.includes("http") ? item.photoUrl : null;
            }
            return item;
          });
          setList(list);
          setTotal(Number(res?.data?.total));
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
        setTotal(0);
        setList([]);
      });
  }, [state]);

  useEffect(() => {
    fetchKaihongPage();
  }, [fetchKaihongPage]);

  useEffect(() => {
    fetchPage();
  }, [fetchPage]);

  useEffect(() => {
    const length = accessGatewayOption.length || operatingSystemOption.length;
    if (addOpen && !length) {
      getAllOptions();
    }
  }, [addOpen]);

  const validateName = (_: any, value: any) => {
    if (value && productNameReg.test(value)) {
      return api.existNameProductManage({ name: value }).then((resp: any) => {
        if (resp.code === 200) {
          if (resp.data?.exist) {
            // const repeatMsg: any = staging.repeat_msg;
            // const errMsg = repeatMsg[resp.data?.typeKey] + name_label;
            return Promise.reject(product_manage.name_already);
          }
        } else {
          return Promise.reject(resp.msg);
        }
      });
    } else {
      return Promise.resolve();
    }
  };

  return (
    <div className={prefix}>
      <div className={`${prefix}-top`}>
        <Form form={filterForm} layout="inline">
          <Form.Item
            name="name"
            getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
            style={{ marginRight: 56 }}
          >
            <Input placeholder={filterFormJson.name_placeholder} onPressEnter={onFilter} style={{ width: 296 }} />
          </Form.Item>
        </Form>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                borderRadius: 0,
                paddingInline: 40,
                paddingBlock: 8,
              },
            },
          }}
        >
          <Button type="primary" onClick={showAddModal}>
            新建
          </Button>
        </ConfigProvider>
      </div>
      <Spin spinning={kaihongLoading} size="large" wrapperClassName={`${prefix}-spin`}>
        <div className={`${prefix}_wrap`}>
          <div className={`${prefix}_wrap-title`}>{product_manage.kaihon_product}</div>
          {kaihongTotal === 0 ? (
            <Empty />
          ) : (
            <div className={`${prefix}-content kaihong_page`}>
              {kaihongList.map((item: any) => {
                return (
                  <div
                    key={item.id}
                    onClick={() => {
                      clickCard(item, true);
                    }}
                    className={`${prefix}-content-item`}
                  >
                    <div className={`${prefix}-content-inner`}>
                      <img
                        src={item?.iconImg ? item?.iconImg : product_manage.init_img}
                        alt=""
                        className={`${prefix}-content-item_initImg`}
                      />
                      <div>
                        <div title={item?.name} className={`${prefix}-content-title one-line-ellipsis`}>
                          {item?.name || two_bars}
                        </div>
                        <div>
                          {item?.deviceType?.text}&nbsp;{item?.accessName}
                        </div>
                      </div>
                      <img src={product_manage.kaihongLeft_bgImg} alt="" className={`${prefix}-content-item_bgImg`} />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <Pagination
            pageSize={kaihongState.limit}
            current={kaihongState.page}
            total={kaihongTotal}
            showSizeChanger
            showQuickJumper
            showTotal={(total) => `共 ${total} 条`}
            align="end"
            className={`${prefix}_page`}
            onShowSizeChange={onKaihongShowSizeChange}
            onChange={(page: number, pageSize: number) => {
              if (page && pageSize) {
                kaihongDispatch({
                  type: CHANGE_PAGINATION,
                  payload: {
                    page,
                    limit: pageSize,
                  },
                });
              }
            }}
          />
        </div>
      </Spin>

      <Spin spinning={loading} size="large" wrapperClassName={`${prefix}-spin`}>
        <div className={`${prefix}_wrap`}>
          <div className={`${prefix}_wrap-title`}>{product_manage.my_product}</div>
          {total === 0 ? (
            <Empty />
          ) : (
            <div className={`${prefix}-content my_page`}>
              {list.map((item: any) => {
                return (
                  <div
                    key={item.id}
                    onClick={() => {
                      clickCard(item);
                    }}
                    className={`${prefix}-content-item`}
                  >
                    <div className={`${prefix}-content-inner`}>
                      <img
                        src={item?.iconImg ? item?.iconImg : product_manage.init_img}
                        alt=""
                        className={`${prefix}-content-item_initImg`}
                      />
                      <div>
                        <div title={item?.name} className={`${prefix}-content-title one-line-ellipsis`}>
                          {item?.name || two_bars}
                        </div>
                        <div>
                          {item?.deviceType?.text}&nbsp;{item?.accessName}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          <Pagination
            pageSize={state.limit}
            current={state.page}
            total={total}
            showSizeChanger
            showQuickJumper
            showTotal={(total) => `共 ${total} 条`}
            align="end"
            className={`${prefix}_page`}
            onShowSizeChange={onShowSizeChange}
            onChange={(page: number, pageSize: number) => {
              if (page && pageSize) {
                dispatch({
                  type: CHANGE_PAGINATION,
                  payload: {
                    page,
                    limit: pageSize,
                  },
                });
              }
            }}
          />
        </div>
      </Spin>
      <Modal
        title={create + product_manage.product}
        centered
        confirmLoading={addOpenLoading}
        open={addOpen}
        okText={add_create}
        onOk={handleAddOpenOk}
        onCancel={handleAddCancel}
      >
        <Form form={addForm}>
          <Form.Item
            name="name"
            label={addFormJson.product_name}
            getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
            rules={[
              { required: true, message: addFormJson.input_placeholder + addFormJson.product_name },
              {
                pattern: productNameReg,
                message: product_manage.name_validator,
              },
              { validator: validateName },
            ]}
          >
            <Input placeholder={addFormJson.input_placeholder + addFormJson.product_name} maxLength={64} showCount />
          </Form.Item>
          <Form.Item
            name="deviceType"
            label={addFormJson.device_type}
            validateDebounce={500}
            rules={[{ required: true, message: addFormJson.select_placeholder + addFormJson.device_type }]}
          >
            <Select
              options={deviceTypeOptions}
              fieldNames={{ label: "dictLabel", value: "dictValue" }}
              filterOption={(input, option) => (option?.dictLabel ?? "").toLowerCase().includes(input.toLowerCase())}
              placeholder={addFormJson.select_placeholder + addFormJson.device_type}
            ></Select>
          </Form.Item>
          <Form.Item
            name="accessId"
            label={addFormJson.access_gateway}
            validateDebounce={500}
            rules={[{ required: true, message: addFormJson.select_placeholder + addFormJson.access_gateway }]}
          >
            <Select
              options={accessGatewayOption}
              fieldNames={{ label: "name", value: "id" }}
              placeholder={addFormJson.select_placeholder + addFormJson.access_gateway}
            ></Select>
          </Form.Item>
          <Form.Item
            name="operatingSystem"
            label={addFormJson.operating_system}
            validateDebounce={500}
            rules={[{ required: true, message: addFormJson.select_placeholder + addFormJson.operating_system }]}
          >
            <Select
              fieldNames={{ label: "text", value: "value" }}
              options={operatingSystemOption}
              placeholder={addFormJson.select_placeholder + addFormJson.operating_system}
            ></Select>
          </Form.Item>
          <Form.Item
            name="model"
            label={addFormJson.product_model}
            validateDebounce={500}
            getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
            rules={[{ required: true, message: addFormJson.input_placeholder + addFormJson.product_model }]}
          >
            <Input placeholder={addFormJson.input_placeholder + addFormJson.product_model} maxLength={30} showCount />
          </Form.Item>
          <Form.Item
            name="description"
            label={addFormJson.product_describe}
            validateDebounce={500}
            rules={[{ required: true, message: addFormJson.input_placeholder + addFormJson.product_describe }]}
            getValueFromEvent={(e) => e.target.value.replace(/(^\s*)|(\s*$)/g, "")}
          >
            <Input.TextArea
              showCount
              maxLength={200}
              placeholder={addFormJson.input_placeholder + addFormJson.product_describe}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default productManage;
